import { Icon } from '@mondra/ui-components'
import { FC } from 'react'
import { NavLink } from 'react-router-dom'
import { ROUTES } from '../../const'

const menuItemClass = ({ isActive }: { isActive: boolean }) =>
  isActive ? 'menu-items-item menu-items-active' : 'menu-items-item'

const OthersNav: FC = () => {
  const { resources, resourcesSources, resourcesSourcesReadonly, sources, waterScarcity } = ROUTES

  return (
    <>
      <NavLink to={waterScarcity} className={menuItemClass}>
        <Icon type="waterUsageImpact" /> Water Scarcity
      </NavLink>
      <NavLink to={resources} className={menuItemClass}>
        <Icon type="resources" /> Resources
      </NavLink>
      <NavLink to={sources} className={menuItemClass}>
        <Icon type="building" /> Sources
      </NavLink>
      <NavLink to={resourcesSourcesReadonly} className={menuItemClass}>
        <Icon type="industry" /> Resource sources
      </NavLink>
      <NavLink to={resourcesSources} className={menuItemClass}>
        <Icon type="resources" /> Resource Country Impacts
      </NavLink>
    </>
  )
}

export default OthersNav
